import { HashRouter as Router } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeContextProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <Router> {/* ✅ Wrap Router outside AuthProvider */}
      <AuthProvider>
        <ThemeContextProvider>
          <CssBaseline />
          <AppRoutes />
        </ThemeContextProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
